// extracted by mini-css-extract-plugin
export default {"bcrsRow":"wEzA7nYKDCuYYp9eqvHK","bcrsLabel":"TNGHSB6GFhphdOLSS4Po","bcrsInfoIcon":"Deke795OEoKX8Ju1sM1e","switchRow":"dXHoQwYdGIPazdYc1p4p"};